import { render, staticRenderFns } from "./modal-offer-chain.vue?vue&type=template&id=464b7fd2&scoped=true"
import script from "./modal-offer-chain.vue?vue&type=script&lang=js"
export * from "./modal-offer-chain.vue?vue&type=script&lang=js"
import style0 from "./modal-offer-chain.vue?vue&type=style&index=0&id=464b7fd2&prod&lang=scss"
import style1 from "./modal-offer-chain.vue?vue&type=style&index=1&id=464b7fd2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464b7fd2",
  null
  
)

export default component.exports